import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useCallback, useState } from "react";
import getExtractInvoiceCharges, {
  ExtractedChargeItem,
} from "../http/getExtractInvoiceCharges";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

const useExtractInvoiceCharges = () => {
  const { getToken } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);
  const [isLoading, setIsLoading] = useState(false);

  const extractCharges = useCallback(
    async (
      siteId: string,
      fileGuid: string
    ): Promise<ExtractedChargeItem[]> => {
      setIsLoading(true);
      try {
        const result = await getExtractInvoiceCharges(
          await getAuthTokenBlocking(getToken, relogin),
          siteId,
          fileGuid
        );
        return result.items;
      } finally {
        setIsLoading(false);
      }
    },
    [getToken, relogin]
  );

  return { extractCharges, isLoading };
};

export default useExtractInvoiceCharges;
